/* Electrodose: external copy of an inline script. Behavior is unchanged. */
(function(){
  var h=document.getElementById('edHamburger');
  var o=document.getElementById('edOverlay');
  if(!h||!o)return;
  function toggle(){
    var open=h.classList.contains('open');
    if(open){
      h.classList.remove('open');
      o.classList.remove('open');
      h.setAttribute('aria-expanded','false');
      document.body.style.overflow='';
    } else {
      h.classList.add('open');
      o.classList.add('open');
      h.setAttribute('aria-expanded','true');
      document.body.style.overflow='hidden';
    }
  }
  h.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();toggle();});
  o.addEventListener('click',function(e){
    if(e.target.tagName==='A'){
      h.classList.remove('open');
      o.classList.remove('open');
      h.setAttribute('aria-expanded','false');
      document.body.style.overflow='';
    }
  });
  /* White + silver pass: Escape closes the open menu and returns focus to the menu button */
  document.addEventListener('keydown',function(e){
    if((e.key==='Escape'||e.key==='Esc')&&h.classList.contains('open')){
      toggle();
      h.focus();
    }
  });
})();
